"use client"

import { useLocale, useTranslations } from "next-intl"
import React from "react"

import { useSigninModal } from "../../../../../SignIn"
import { LanguageSelector, UserProfile } from "../../../index"
import { useUserInfo } from "../../../UserProvider"

/**
 * 顶部工具导航栏 - 客户端组件
 * 处理用户交互：登录按钮、用户信息、语言切换
 */
export const TopUtilityBarClient: React.FC = () => {
  const t = useTranslations("HeaderComp")
  const { userInfo } = useUserInfo()
  const { showSignInModal } = useSigninModal()
  const locale = useLocale()

  const showLoginModal = () => {
    showSignInModal({
      language: locale,
      onLoginSuccess: () => {
        window.location.reload()
      },
      onRegisterSuccess: () => {
        window.location.reload()
      },
    })
  }

  return (
    <div className="topUtilityBarRight">
      <div className="userActionsSection">
        {userInfo ? (
          <UserProfile />
        ) : (
          <div onClick={showLoginModal} className="signInButton">
            {t("common.SignIn")}
          </div>
        )}
        <div className="dividerLine" />
        <LanguageSelector />
      </div>
    </div>
  )
}
